import React, { useState, useEffect } from "react"
import { Spin } from "antd"
import { useHistory } from "react-router-dom"
import CryptoJS from "crypto-js"
import { networkDomains } from "../../domains"

const customStyles = `
  /* Responsive styles for mobile devices */
  @media (max-width: 768px) {
    .registration-container {
      padding: 40px 16px !important;
    }

    .registration-card {
      width: 100% !important;
      padding: 24px 20px !important;
    }

    .registration-title {
      font-size: 20px !important;
    }
  }

  /* Desktop styles */
  @media (min-width: 769px) {
    .registration-container {
      padding: 104px 88px !important;
    }

    .registration-card {
      width: 464px !important;
      padding: 32px 48px !important;
    }

    .registration-title {
      font-size: 24px !important;
    }
  }
`;

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

const key1 = "981239812312312323"
const key2 = "9234809823948394"

function loadFromSessionStorage(data, key) {
  try {
    const serializedState = sessionStorage.getItem(data)
    if (serializedState === null) {
      return undefined
    }
    const decrypted = CryptoJS.AES.decrypt(serializedState, key).toString(
      CryptoJS.enc.Utf8
    )
    return JSON.parse(decrypted)
  } catch {
    return undefined
  }
}

function saveToSessionStorage(state) {
  try {
    const serializedState = JSON.stringify(state)
    const encrypted = CryptoJS.AES.encrypt(serializedState, key2)
    sessionStorage.setItem("state", encrypted)
  } catch (e) {
    console.log(e)
  }
}

const SignupPage = ({ domains, ...props }) => {
  const [creating, setCreating] = useState(true);
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const onFinish = (formData) => {
    saveToSessionStorage({ ...formData })
    props.history.push({ pathname: `/signup-details` })
  }

  useEffect(() => {
    loadFromSessionStorage("state", key2)
    const timer = setTimeout(() => {
      setCreating(false);
      props.history.push({ pathname: `/signup-details` });
    }, 3000);

    return () => clearTimeout(timer);
  }, [props.history])

  return (
    <div 
      className="registration-container"
      style={{
        backgroundColor: "#EEF2F7", 
        minHeight: "100vh", 
        padding: isMobile ? "40px 16px" : "104px 88px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 48
      }}
    >
      <style>{customStyles}</style>
      
      <div style={{ 
        padding: 20.17, 
        overflow: 'hidden', 
        flexDirection: 'column', 
        justifyContent: 'flex-start', 
        alignItems: 'flex-start', 
        gap: 11.53, 
        display: 'flex' 
      }}>
        <div style={{ 
          width: 67.66, 
          height: 67.66, 
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src="images/logo.svg" 
            style={{ 
              width: "100%",
              height: "100%",
              objectFit: "contain"
            }} 
            alt="Tigg Logo"
          />
        </div>
      </div>

      <div style={{ 
        flexDirection: 'column', 
        justifyContent: 'flex-start', 
        alignItems: 'flex-start', 
        gap: 24, 
        display: 'flex' 
      }}>
        <div 
          className="registration-card"
          style={{
            width: isMobile ? "100%" : 464,
            maxWidth: 550,
            paddingLeft: isMobile ? 20 : 48,
            paddingRight: isMobile ? 20 : 48,
            paddingTop: 32,
            paddingBottom: 32,
            background: 'white',
            boxShadow: '0px 28px 62px rgba(37, 78, 207, 0.03)',
            borderRadius: 16,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 20,
            display: 'flex'
          }}
        >
          <Spin 
            size="large" 
            style={{
              fontSize: '24px'
            }}
          />
          <div style={{
            alignSelf: 'stretch',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: 16,
            display: 'inline-flex'
          }}>
            <div style={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 2,
              display: 'inline-flex',
              width: '100%'
            }}>
              <div 
                className="registration-title"
                style={{
                  alignSelf: 'stretch',
                  textAlign: 'center',
                  color: '#343C46',
                  fontSize: isMobile ? 20 : 24,
                  fontFamily: 'Inter',
                  fontWeight: '700',
                  wordWrap: 'break-word'
                }}
              >
                Creating Your Account
              </div>
              <div style={{
                alignSelf: 'stretch',
                textAlign: 'center',
                color: '#969798',
                fontSize: 14,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word',
                lineHeight: '20px'
              }}>
                Please wait while we set up your account...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignupPage
